module.exports = __webpack_public_path__ + "img/apply.8de48496.png";